// This class handles the form mapping for the Tennessee Goods and Services form.
// This was necessary since the Tennessee G&S form has no supplemental page.
import { type sectionMapConfig } from './GoodsAndServicesMapConfig'
import GoodsAndServicesForm from '@/components/documents/Foxit/FormMapping/GoodsAndServicesForm'

export default class TennesseeGoodsAndServicesForm extends GoodsAndServicesForm {
	protected readonly hasSupplementalPage = false
	protected readonly sharesEmbalmingAndRefrigerationLine = false

	// Override this method from GoodsAndServicesForm to handle comma separating items
	protected generateFieldMappingsFromSectionConfig(
		sectionConfig: sectionMapConfig,
		sectionItemsMap: Map<string, any[]>
	) {
		return sectionConfig.map(({ name, category, prop }) => {
			let mapItem = sectionItemsMap.get(category)
			let itemValue: string | number = ''

			if (!mapItem) {
				return {
					name,
					value: '',
				}
			}

			if (mapItem.length > 1) {
				let commaSeparatedItems: string[] = []

				mapItem.forEach((item) => {
					const itemShortDescription = item[prop]
						? `${item[prop]}`
						: item.shortDescription
							? `${item.shortDescription}`
							: ''

					commaSeparatedItems.push(itemShortDescription)
				})

				const commaSeparatedItemsString = commaSeparatedItems.join(', ')

				itemValue =
					prop === 'price'
						? this.fieldPrices[category] === 0
							? 'Incl'
							: (this.fieldPrices[category].toFixed(2) ?? '')
						: commaSeparatedItemsString
			} else {
				itemValue = this.setItemValueForSectionItems(
					category,
					sectionItemsMap,
					prop,
					false
				)
			}

			return {
				name,
				value: itemValue ?? '',
			}
		})
	}
}
